// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610230535/js/" + chunkId + "." + {"44":"43a59869","225":"ec3ad2d4","481":"5ad0ad04","486":"7335a5ad","770":"c00aa0cc"}[chunkId] + ".0.3963660286717485.chunk.js";
};